export function getUserColor(userId) {
  if (!userId && userId !== 0) return "#000000";
  const numericUserId = Number(userId);
  if (!Number.isFinite(numericUserId)) return "#000000";

  const hue = (numericUserId * 137.508) % 360;
  return hslToHex(hue, 70, 50);
}

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;

  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n)-3, Math.min(9-k(n), 1)));
  const toHex = x => Math.round(x * 255).toString(16).padStart(2, "0");

  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
}

export function getCursorSvg(userId) {
  const color = getUserColor(userId);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="${color}" viewBox="0 0 16 16">
      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
    </svg>
  `;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}
